var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bottle-feature-outer" }, [
    _c("div", { staticClass: "bottle-feature-display" }, [
      _c("div", { staticClass: "content-region content-region-1" }, [
        _c(
          "div",
          { staticClass: "upper-region" },
          [
            _vm.content.title
              ? _c("h3", [
                  _vm._v(
                    "\n          " + _vm._s(_vm.content.title) + "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.content.subtitle
              ? _c("h5", [
                  _vm._v(
                    "\n          " + _vm._s(_vm.content.subtitle) + "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.content.review
              ? _c("StarsRating", {
                  staticClass: "product-rating",
                  attrs: {
                    rating: _vm.content.review.rating,
                    "rating-amount": _vm.content.review.reviews,
                    row: "true",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.content.description
          ? _c("div", { staticClass: "description" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.content.description) + "\n      "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.content.action.enabled
          ? _c(
              "div",
              { staticClass: "actions" },
              [
                _c("HighlightButton", {
                  attrs: {
                    url: _vm.content.action.linkUrl,
                    title: _vm.content.action.linkTitle,
                    "button-type": _vm.content.action.buttonType,
                    "button-style": _vm.content.action.buttonStyle,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "image-region" },
        [
          _c("standard-image-display", {
            attrs: {
              alt: _vm.content.image.alt,
              title: _vm.content.image.alt,
              source: _vm.content.image.fileStore.presignedURL,
              "object-position": _vm.content.image.objectPosition,
              "object-fit": _vm.content.image.objectFit,
              "lazy-loading": "lazy",
              aspect: _vm.content.image.imageAspectRatio,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.content.awards
        ? _c(
            "div",
            { staticClass: "content-region content-region-2" },
            [_c("AwardList", { attrs: { items: _vm.content.awards } })],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }